import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MastercolorService {

  readonly rootUrl = environment.baseUrl;
  constructor(private http: HttpClient) {}
  getMasterColorList(Active:any):Observable<any>
  {
    return this.http.get<any>(this.rootUrl +'/Common/GetMasterColorlist',{params:{Active}})
  }
  ManageMasterColor(bo:any):Observable<any>
  {
    return this.http.post<any>(this.rootUrl +'/Common/ManageMasterColor',bo)
  }
  ActiveInactiveColor(id:number):Observable<any>
  {
    return this.http.get<any>(this.rootUrl +'/Common/ActiveInactiveColor',{params:{id}})
  }
}
